import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Session } from 'src/app/shared/common/enums';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PartnerService {

  constructor(private http: HttpClient) {}

  public getpartners(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/api/parceirosmonitoramento`);
  }

  public setPartnerId(id: number | string) {
      window.sessionStorage.setItem(Session.PARTNER_ID, id+'');
  }

  public getPartnerId(): string {
    return window.sessionStorage.getItem(Session.PARTNER_ID) || '';
  }
}
